import {
  Breadcrumb,
  Button,
  Form,
  Input,
  Popconfirm,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { getRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { ReactComponent as ArchiveRestore } from "../../image/ArchiveRestore.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { UndoOutlined } from "@ant-design/icons";

const { Search } = Input;

const ArchivedSuberb = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [archivedCityList, setArchivedCityList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getCityArchiveList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest(
          "suburb/archived-suburb-list/",
          state
        );
        if (apiResponse.status) {
          // const sortedData = apiResponse.data.results.sort((a, b) => {
          //   return b.id - a.id;
          // });
          setArchivedCityList(apiResponse.data.results);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archive_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getCityArchiveList();
  }, [state, reload, t]);

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "-id";

    if (sortField === "area" && sortOrder === "ascend") {
      sortingEnumKey = "area";
    }
    if (sortField === "area" && sortOrder === "descend") {
      sortingEnumKey = "-area";
    }
    if (sortField === "zone" && sortOrder === "ascend") {
      sortingEnumKey = "zone__zone";
    }
    if (sortField === "zone" && sortOrder === "descend") {
      sortingEnumKey = "-zone__zone";
    }
    if (sortField === "state_name" && sortOrder === "ascend") {
      sortingEnumKey = "state__name";
    }
    if (sortField === "state_name" && sortOrder === "descend") {
      sortingEnumKey = "-state__name";
    }
    if (sortField === "city" && sortOrder === "ascend") {
      sortingEnumKey = "city__name";
    }
    if (sortField === "city" && sortOrder === "descend") {
      sortingEnumKey = "-city__name";
    }
    if (sortField === "country_name" && sortOrder === "ascend") {
      sortingEnumKey = "country__name";
    }
    if (sortField === "country_name" && sortOrder === "descend") {
      sortingEnumKey = "-country__name";
    }
    return sortingEnumKey;
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {},
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("suburb/restore-suburb/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("subrub_restore_successfully"));
        setReload(!reload);
        setSelectedRow([]);
        navigate("/suburb");
      } else {
        ErrorNotificationMsg(t("error_in_restore_subrub"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const columns = [
    {
      title: "Suburb",
      dataIndex: "area",
      key: "area",
      sorter: true,
    },

    {
      title: "Run",
      dataIndex: "zone_name",
      key: "zone",
      sorter: true,
    },
    {
      title: "State",
      dataIndex: "state_name",
      key: "state_name",
      sorter: true,
    },
    {
      title: "Country",
      dataIndex: "country_name",
      key: "country_name",
      sorter: true,
    },

    {
      title: "Action",
      fixed: "right",
      width: "100px",
      key: "operation",

      render: (text, record) => (
        <Space>
          {/* <Tooltip
            color={colors}
            placement="right"
            title={<span style={{ color: "#fff" }}>Restore</span>}
          > */}
          <Popconfirm
            className="action"
            title={t("pop_restore_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleRestore(record.id)}
          >
            <ArchiveRestore className="ArchiverestorImg" />
          </Popconfirm>
          {/* </Tooltip> */}
        </Space>
      ),
    },
  ];
  const colors = ["#737373"];
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("Archived Suburb")}</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/suburb">{t("Suburb")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Archived Suburb")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp" style={{ height: "40px" }}>
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                      style={{
                        width: 250,
                      }}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label="Restore"
                />
              </Popconfirm>
            )}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="PR-body">
          <Table
            rowSelection={rowSelection}
            rowKey={(record) => record.id}
            columns={columns}
            dataSource={archivedCityList}
            scroll={{ x: 800 }}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              // total: totalCount,
              showSizeChanger: true,
              // showTotal: (totalCount) => `Total ${totalCount} items`,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              locale: {
                items_per_page: "Items / Page", // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
          <div className="FormFooter Container">
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("pl_back_to_list")}
              onClick={() => navigate(`/suburb`)}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ArchivedSuberb;
